import { OrderDelivery } from './components/types';

export function groupByTaxRate(deliveries: OrderDelivery[] | []) {
  if (!deliveries?.length) return { taxesByPercentage: [], totalPercentes: 0 };

  let totalPercentes = 0;
  const groupedTotals: { [key: string]: number } = {};
  deliveries.forEach((delivery) =>
    delivery.items.forEach((item) => {
      const taxRate = item.taxRate ? item.taxRate : 0;
      const price = (item.price || 0) * (item.quantity || 1);
      const tax = price * (taxRate / 100);
      if (!groupedTotals[taxRate]) {
        groupedTotals[taxRate] = 0;
      }
      groupedTotals[taxRate] += tax;
      totalPercentes += tax;
    }),
  );
  const taxesByPercentage = Object.keys(groupedTotals).map((key) => ({
    percent: parseInt(key),
    value: parseFloat(groupedTotals[key].toFixed(2)),
  }));
  return { taxesByPercentage, totalPercentes };
}
